import axios from "axios";
import router from "../router";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../config";

// Use a dedicated instance so other modules' axios interceptors (e.g. cars.js) don't show a second dialog
const authAxios = axios.create({ baseURL: API_BASE_URL });

function getLoginErrorMessage(error) {
  return (
    error.response?.data?.data?.message ||
    error.response?.data?.message ||
    "Something went wrong. Please try again."
  );
}

const login = async (email, password) => {
  try {
    const res = await authAxios.post("/auth/login", {
      email: email.toLowerCase(),
      password,
    });
    return res;
  } catch (error) {
    const message = getLoginErrorMessage(error);
    const isAdminLoginRequired =
      typeof message === "string" &&
      message.toLowerCase().includes("user credentials required");

    if (isAdminLoginRequired) {
      await Swal.fire({
        title: "Use Admin Login",
        text: "This account uses admin login. Go to Admin login to continue.",
        icon: "info",
        confirmButtonText: "Go to Admin login",
      });
      router.push("/admin/login");
    } else {
      Swal.fire({
        title: "Error!",
        text: message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    throw {
      code: error.response?.status || 417,
      message,
    };
  }
};

const adminLogin = async (email, password) => {
  try {
    return await authAxios.post("/auth/admin-login", {
      email: email.toLowerCase(),
      password,
    });
  } catch (error) {
    const message = getLoginErrorMessage(error);
    Swal.fire({
      title: "Error!",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    });
    throw {
      code: error.response?.status || 417,
      message,
    };
  }
};

const register = async (
  fullName,
  email,
  password,
  creditScore,
  finance,
  leasing,
  city,
  state,
  zipCode,
  phoneNumber,
  tradeInVehicle,
  tradeInDetails
) => {
  try {
    const response = await authAxios.post("/auth/signup", {
      fullName,
      email,
      password,
      creditScore,
      finance,
      leasing,
      type: "user",
      city,
      state,
      zipCode,
      phoneNumber,
      tradeInVehicle,
      tradeInDetails,
    });
    return response;
  } catch (error) {
    console.error(error.response);
    // throw {
    //     code: error.response.status || 417,
    //     message: error.response.data.data.message || 'something went wrong please try again'
    // };
  }
};

const forgotPassword = async (email, accountType = "user") => {
  return authAxios.post("/auth/forgot-password", {
    email: email.toLowerCase(),
    accountType,
  });
};

const validateResetToken = async (token, accountType = "user") => {
  return authAxios.get("/auth/reset-password/validate", {
    params: { token, accountType },
  });
};

const resetPassword = async (token, password, accountType = "user") => {
  try {
    return await authAxios.post("/auth/reset-password", {
      token,
      password,
      accountType,
    });
  } catch (error) {
    const message = getLoginErrorMessage(error);
    Swal.fire({
      title: "Error!",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    });
    throw error;
  }
};

export default {
  login,
  adminLogin,
  register,
  forgotPassword,
  validateResetToken,
  resetPassword,
};
